module services {
    export module master {
        export class customAttributeAnswerOptionService implements interfaces.master.ICustomAttributeAnswerOptionService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all Product Types for a dropdown/autocomplete list
            GetDropDownListByAttribute(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "CustomAttributeAnswerOption/GetDropDownListByAttribute", {
                    attributeId: '@attributeId'
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("customAttributeAnswerOptionService", services.master.customAttributeAnswerOptionService);
}